<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="weather-list">
        <template slot="header">
          <el-form inline size="small">
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-plus"
                style="background-color: #00c49c; border-color: #00c49c;"
                @click="handleAdd"
              >{{ $t('button.tianjia') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <el-table
            v-loading="queryLoading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            :data="tablist.queryResults"
            style="width: 100%"
            height="calc(100% - 50px)"
          >
            <el-table-column
              label="SN"
              prop="gatewaysn"
              align="center"
              width="150px"
            />
            <el-table-column
              :label="$t('text.zt')"
              prop="status"
              align="center"
              :formatter="statusFormat"
            />
            <el-table-column
              :label="$t('text.mc')"
              prop="alias"
              align="center"
            />
            <el-table-column
              label="风向传感器"
              align="center"
            >
              <template v-slot="scope">
                <span>{{ scope.row.m1==='0'?'未安装':'已安装' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="太阳辐射传感器"
              align="center"
            >
              <template v-slot="scope">
                <span>{{ scope.row.m2==='0'?'未安装':'已安装' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="三合一传感器"
              align="center"
            >
              <template v-slot="scope">
                <span>{{ scope.row.m3==='0'?'未安装':'已安装' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="风速传感器"
              align="center"
            >
              <template v-slot="scope">
                <span>{{ scope.row.m4==='0'?'未安装':'已安装' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="直照辐射"
              align="center"
            >
              <template v-slot="scope">
                <span>{{ scope.row.m5==='0'?'未安装':'已安装' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="贴片温度传感器"
              align="center"
            >
              <template v-slot="scope">
                <span>{{ scope.row.m6==='0'?'未安装':'已安装' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="雨量计"
              align="center"
            >
              <template v-slot="scope">
                <span>{{ scope.row.m7==='0'?'未安装':'已安装' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('text.rwsj')"
              prop="createtime"
              align="center"
            />
            <el-table-column
              :label="$t('text.gxsj')"
              prop="sitetime"
              align="center"
            />
            <el-table-column
              :label="$t('text.cz')"
              prop="createtime"
              align="center"
            >
              <template v-slot="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleDelete(scope.row)"
                >{{ $t('button.sc') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :total="total"
            background
            layout="total, prev, pager, next"
            @current-change="getPageData"
          />
        </template>
      </el-card>
      <el-dialog
        :title="$t(dialogAddTitle)"
        :visible.sync="showAddDialog"
        width="600px"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="deviceForm"
          label-width="100px"
        >
          <el-form-item :label="$t('text.cjqxlh')">
            <el-input
              v-model="sn"
              clearable
            />
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="handleAddSubmit"
          >{{ $t('button.qd') }}</el-button>
          <el-button @click="showAddDialog = false">{{ $t('button.qx') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { QueryWeathereReals } from '@/api/Weather'
import { DeleteGateways } from '@apis/Device'
import { BindGatewayToStation } from '@/api/Stations'
export default {
  name: 'WeatherList',
  data () {
    return {
      queryLoading: false,
      queryParams: { orgid: this.$store.getters.station.id },
      tablist: { },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      showAddDialog: false,
      dialogAddTitle: 'text.tjsb',
      sn: '',
      deviceForm: {}
    }
  },
  mounted () {
    this.getPageData()
  },
  methods: {
    getPageData () {
      this.queryLoading = true
      QueryWeathereReals({
        page: this.pageNum,
        perPage: this.pageSize,
        orderBy: '',
        whereCondition: JSON.stringify(this.queryParams)
      }).then(res => {
        this.tablist = res.data
        this.total = res.data.totalCount
      }).then(() => {
        this.queryLoading = false
      }).catch(() => {
        this.queryLoading = false
        this.$messgae({ message: '查询设备列表失败', type: 'error' })
      })
    },
    handleAdd () {
      this.showAddDialog = true
    },
    handleAddSubmit () {
      BindGatewayToStation({
        id: this.$store.getters.station.id,
        tag: this.sn
      }).then(() => {
        this.$msgSuccess(this.$t('notice.tjsbcg'))
        this.getTableData()
        this.showAddDialog = false
      }).catch((err) => {
        throw new Error(err)
      })
    },
    handleQuery () {
      this.pageNum = 1
      this.getPageData()
    },
    statusFormat (row, column, cellValue, index) {
      if (cellValue === '0') {
        return '正常'
      } else if (cellValue === '2') {
        return '离线'
      }
    },
    handleDelete (row) {
      this.$confirm(this.$t('notice.sbsc'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        type: 'warning'
      })
        .then(() => {
          return DeleteGateways({ id: row.id })
        })
        .then(() => {
          this.$msgSuccess(this.$t('notice.sccg'))
          this.getTableData()
        })
        .catch(() => {})
    },
    tableRowClass ({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row'
    },
  },
}
</script>
<style scoped>
.weather-list{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}

.weather-list>>> .el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: none;
}
.weather-list>>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.weather-list>>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.weather-list>>> .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px;
  box-sizing: border-box;
}

.weather-list>>> .el-card__body .el-table {
  border: none;
}
.weather-list>>> .el-card__body .el-pagination {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.weather-list>>> .el-card__body .el-table--border::after, .el-table--group::after, .el-table::before{
  background-color: transparent;
}
</style>

